/** Dashboard layout limits (two-column layout, all levels). */
export const DASHBOARD_LAYOUT = {
  /** Deadline rows shown before "+ N more". */
  DEADLINES_PREVIEW: 3,
  /** Templates shown per checklist period before "Show all". */
  TEMPLATE_PREVIEW_LIMIT: 5,
  /** Recent activity rows visible before the list scrolls. */
  RECENT_ACTIVITY_VISIBLE_ROWS: 5,
} as const;

export type DashboardLayoutKey = keyof typeof DASHBOARD_LAYOUT;

/** Anchor for My checklist (Deadlines rows scroll here). */
export const DASHBOARD_REPORTING_CHECKLIST_ID = 'dashboard-reporting-checklist';

/** Per-period anchor id prefix inside My checklist. */
export const DASHBOARD_CHECKLIST_PERIOD_ANCHOR_PREFIX = 'dashboard-checklist-period-';

export function checklistPeriodAnchorId(reportTagId: number): string {
  return `${DASHBOARD_CHECKLIST_PERIOD_ANCHOR_PREFIX}${reportTagId}`;
}
